import '../../App.css';
import Footer  from '../footer/footer';
import Navbar from '../navbar/navbar';
import React, { useState } from 'react';
import iso from '../../assets/iso.png'
import iso1 from '../../assets/iso1.png'
import iso2 from '../../assets/iso2.png'
import iso3 from '../../assets/iso3.png'
import flowmeter from '../../assets/Flowmeter.jpg'
import Transmitter from '../../assets/Transmitter.jpg'
import compressor from '../../assets/compressor.png'
import valves from '../../assets/valves.png'
import pumps from '../../assets/pumps.png'
import fasteners  from '../../assets/fasteners.png'
import boilers  from '../../assets/Boilers.jpg'
import oilGasImage1 from '../../assets/oilGasImage1.jpg'
import { RiCustomerService2Fill, RiShipLine } from "react-icons/ri";
import { GrUserExpert } from 'react-icons/gr';
import { AiOutlineGlobal } from 'react-icons/ai';
import { HiOutlineBadgeCheck } from 'react-icons/hi';
import { SlBadge } from 'react-icons/sl';
import { Helmet } from 'react-helmet';
import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';
import { FaIndustry } from 'react-icons/fa6';
import '../../App.css'



const Home: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
  
    const openModal = (imageSrc: string) => {
      setModalImageSrc(imageSrc);
      setIsModalOpen(true);
    };
  
    const closeModal = () => {
      setIsModalOpen(false);
      setModalImageSrc('');
    };
  
    const handleClickOutside = (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) {
        closeModal();
      }
    };
    return (
      <><Helmet>
      {/* Basic Meta */}
      <title>Global Manufacturer & Exporter of Oil & Gas Equipment</title>
      <meta 
        name="description" 
        content="City Cat International is a leading ISO 9001:2015 certified manufacturer & global exporter of oil & gas equipment including valves, compressors, pumps, flowmeters & boilers." 
      />
      <meta 
        name="keywords" 
        content="City Cat International, oil and gas equipment manufacturer, industrial equipment exporter India, ISO 9001 certified supplier, valves manufacturer, compressors exporter, pumps and flowmeters, transmitters and boilers, fasteners exporter, oil & gas industry equipment" 
      />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href="https://www.oilandgasindustrialequipmentsupply.com" />
    
      {/* Favicon */}
      <link rel="icon" type="image/png" href="https://www.oilandgasindustrialequipmentsupply.com/assets/logo.png" />
    
      {/* Open Graph Meta */}
      <meta property="og:title" content="About City Cat International - Global Manufacturer & Exporter of Oil & Gas Equipment" />
      <meta property="og:description" content="Learn more about City Cat International - a leading global manufacturer and exporter of premium industrial equipment including valves, pumps, compressors, and more for the oil and gas industry." />
      <meta property="og:url" content="https://www.oilandgasindustrialequipmentsupply.com " />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://www.oilandgasindustrialequipmentsupply.com/assets/about-banner.jpg" />
    
      {/* Twitter Meta */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="About City Cat International - Global Manufacturer & Exporter of Oil & Gas Equipment" />
      <meta name="twitter:description" content="City Cat International is a global leader in manufacturing and exporting oil & gas equipment. Discover our legacy, expertise, and commitment to quality." />
      <meta name="twitter:image" content="https://www.oilandgasindustrialequipmentsupply.com/assets/about-banner.jpg" />
    
      {/* JSON-LD Structured Data */}
      <script type="application/ld+json">
        {`
        {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "City Cat International",
          "url": "https://www.oilandgasindustrialequipmentsupply.com",
          "logo": "https://www.oilandgasindustrialequipmentsupply.com/assets/logo.png",
          "description": "City Cat International is a global manufacturer and exporter of oil & gas equipment including valves, compressors, pumps, flowmeters, transmitters, boilers, and fasteners.",
          "foundingDate": "1990",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+91-9819600149",
            "contactType": "Customer Service",
            "areaServed": "Worldwide",
            "availableLanguage": ["English"]
          },
          "sameAs": [
            "https://www.linkedin.com/company/city-cat-international-limited-oil-and-gas-division"
          ]
        }
        `}
      </script>
    </Helmet><><Navbar></Navbar>

     <section className="relative bg-white py-16 mt-20 OILGasBG flex items-center justify-center">
      <div className="container mx-auto px-4 text-center HomeContent">
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 ">
         Oil & Gas Industrial Equipment Manufacturer & Global Supplier
        </h1>
        <p className="text-xl text-white max-w-3xl mx-auto mb-10">
          ISO-Certified Valves, Compressors, Pumps, Flowmeters & More - Delivering Reliability Since 1990
        </p>
        <div className="flex justify-center gap-4">
          <Link     
            to="/contact" 
            className="bg-rose-600 hover:bg-rose-700 text-white font-bold py-3 px-6 rounded-lg transition duration-300"
          >
            Request a Quote
          </Link>
        
        </div>
      </div>
    </section>


      <main className="relative min-h-full flex flex-col justify-center bg-white overflow-hidden ">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10">
          <div className="group flex max-md:flex-col justify-center gap-1">
            <article className="group/article relative w-full rounded-xl overflow-hidden md:group-hover:[&:not(:hover)]:w-[20%] md:group-focus-within:[&:not(:focus-within):not(:hover)]:w-[20%] transition-all duration-300 ease-[cubic-bezier(.5,.85,.25,1.15)] before:absolute before:inset-x-0 before:bottom-0 before:h-1/3 before:bg-gradient-to-t before:from-black/50 before:transition-opacity md:before:opacity-0 md:hover:before:opacity-100 focus-within:before:opacity-100 after:opacity-0 md:group-hover:[&:not(:hover)]:after:opacity-100 md:group-focus-within:[&:not(:focus-within):not(:hover)]:after:opacity-100 after:absolute after:inset-0 after:bg-white/30 after:backdrop-blur after:transition-all focus-within:ring focus-within:ring-indigo-300">
              <Link className="absolute inset-0 text-white z-10" to="/oil-gas-compressors">
                <span className="text-center absolute inset-x-0 bottom-0 text-7xl font-bold p-6 md:px-12 md:py-8 md:whitespace-nowrap md:truncate md:opacity-0 group-hover/article:opacity-100 group-focus-within/article:opacity-100 md:translate-y-2 group-hover/article:translate-y-0 group-focus-within/article:translate-y-0 transition duration-200 ease-[cubic-bezier(.5,.85,.25,1.8)] group-hover/article:delay-300 group-focus-within/article:delay-300">Compressors</span>
              </Link>
              <img className="object-cover h-72 md:h-[480px] md:w-auto" loading='eager' src={compressor} width="960" height="480" alt="Compressors" />
            </article>
            <article className="group/article relative w-full rounded-xl overflow-hidden md:group-hover:[&:not(:hover)]:w-[20%] md:group-focus-within:[&:not(:focus-within):not(:hover)]:w-[20%] transition-all duration-300 ease-[cubic-bezier(.5,.85,.25,1.15)] before:absolute before:inset-x-0 before:bottom-0 before:h-1/3 before:bg-gradient-to-t before:from-black/50 before:transition-opacity md:before:opacity-0 md:hover:before:opacity-100 focus-within:before:opacity-100 after:opacity-0 md:group-hover:[&:not(:hover)]:after:opacity-100 md:group-focus-within:[&:not(:focus-within):not(:hover)]:after:opacity-100 after:absolute after:inset-0 after:bg-white/30 after:backdrop-blur after:transition-all focus-within:ring focus-within:ring-indigo-300">
              <Link className="absolute inset-0 text-white z-10" to="/industrial-valves">
                <span className="text-center absolute inset-x-0 bottom-0 text-7xl font-bold p-6 md:px-12 md:py-8 md:whitespace-nowrap md:truncate md:opacity-0 group-hover/article:opacity-100 group-focus-within/article:opacity-100 md:translate-y-2 group-hover/article:translate-y-0 group-focus-within/article:translate-y-0 transition duration-200 ease-[cubic-bezier(.5,.85,.25,1.8)] group-hover/article:delay-300 group-focus-within/article:delay-300">Valves</span>
              </Link>
              <img className="object-cover h-72 md:h-[480px] md:w-auto" src={valves} width="960" height="480" alt="Valves" />
            </article>
            <article className="group/article relative w-full rounded-xl overflow-hidden md:group-hover:[&:not(:hover)]:w-[20%] md:group-focus-within:[&:not(:focus-within):not(:hover)]:w-[20%] transition-all duration-300 ease-[cubic-bezier(.5,.85,.25,1.15)] before:absolute before:inset-x-0 before:bottom-0 before:h-1/3 before:bg-gradient-to-t before:from-black/50 before:transition-opacity md:before:opacity-0 md:hover:before:opacity-100 focus-within:before:opacity-100 after:opacity-0 md:group-hover:[&:not(:hover)]:after:opacity-100 md:group-focus-within:[&:not(:focus-within):not(:hover)]:after:opacity-100 after:absolute after:inset-0 after:bg-white/30 after:backdrop-blur after:transition-all focus-within:ring focus-within:ring-indigo-300">
              <Link className="absolute inset-0 text-white z-10" to="/oil-gas-pumps">
                <span className="text-center absolute inset-x-0 bottom-0 text-7xl font-bold p-6 md:px-12 md:py-8 md:whitespace-nowrap md:truncate md:opacity-0 group-hover/article:opacity-100 group-focus-within/article:opacity-100 md:translate-y-2 group-hover/article:translate-y-0 group-focus-within/article:translate-y-0 transition duration-200 ease-[cubic-bezier(.5,.85,.25,1.8)] group-hover/article:delay-300 group-focus-within/article:delay-300">Pumps</span>
              </Link>
              <img className="object-cover h-72 md:h-[480px] md:w-auto" src={pumps} width="960" height="480" alt="Pumps" />
            </article>
            <article className="group/article relative w-full rounded-xl overflow-hidden md:group-hover:[&:not(:hover)]:w-[20%] md:group-focus-within:[&:not(:focus-within):not(:hover)]:w-[20%] transition-all duration-300 ease-[cubic-bezier(.5,.85,.25,1.15)] before:absolute before:inset-x-0 before:bottom-0 before:h-1/3 before:bg-gradient-to-t before:from-black/50 before:transition-opacity md:before:opacity-0 md:hover:before:opacity-100 focus-within:before:opacity-100 after:opacity-0 md:group-hover:[&:not(:hover)]:after:opacity-100 md:group-focus-within:[&:not(:focus-within):not(:hover)]:after:opacity-100 after:absolute after:inset-0 after:bg-white/30 after:backdrop-blur after:transition-all focus-within:ring focus-within:ring-indigo-300">
              <Link className="absolute inset-0 text-white z-10" to="/industrial-fasteners">
                <span className="text-center absolute inset-x-0 bottom-0 text-7xl font-bold p-6 md:px-12 md:py-8 md:whitespace-nowrap md:truncate md:opacity-0 group-hover/article:opacity-100 group-focus-within/article:opacity-100 md:translate-y-2 group-hover/article:translate-y-0 group-focus-within/article:translate-y-0 transition duration-200 ease-[cubic-bezier(.5,.85,.25,1.8)] group-hover/article:delay-300 group-focus-within/article:delay-300">Fasteners</span>
              </Link>
              <img className="object-cover h-72 md:h-[480px] md:w-auto" src={fasteners} width="960" height="480" alt="Fasterners" />
            </article>
            <article className="group/article relative w-full rounded-xl overflow-hidden md:group-hover:[&:not(:hover)]:w-[20%] md:group-focus-within:[&:not(:focus-within):not(:hover)]:w-[20%] transition-all duration-300 ease-[cubic-bezier(.5,.85,.25,1.15)] before:absolute before:inset-x-0 before:bottom-0 before:h-1/3 before:bg-gradient-to-t before:from-black/50 before:transition-opacity md:before:opacity-0 md:hover:before:opacity-100 focus-within:before:opacity-100 after:opacity-0 md:group-hover:[&:not(:hover)]:after:opacity-100 md:group-focus-within:[&:not(:focus-within):not(:hover)]:after:opacity-100 after:absolute after:inset-0 after:bg-white/30 after:backdrop-blur after:transition-all focus-within:ring focus-within:ring-indigo-300">
              <Link className="absolute inset-0 text-white z-10" to="/digital-flow-meters">
                <span className="text-center absolute inset-x-0 bottom-0 text-7xl font-bold p-6 md:px-12 md:py-8 md:whitespace-nowrap md:truncate md:opacity-0 group-hover/article:opacity-100 group-focus-within/article:opacity-100 md:translate-y-2 group-hover/article:translate-y-0 group-focus-within/article:translate-y-0 transition duration-200 ease-[cubic-bezier(.5,.85,.25,1.8)] group-hover/article:delay-300 group-focus-within/article:delay-300">Flowmeter</span>
              </Link>
              <img className="object-cover h-72 md:h-[480px] md:w-auto" src={flowmeter} width="960" height="480" alt="flowmeter" />
            </article>
            <article className="group/article relative w-full rounded-xl overflow-hidden md:group-hover:[&:not(:hover)]:w-[20%] md:group-focus-within:[&:not(:focus-within):not(:hover)]:w-[20%] transition-all duration-300 ease-[cubic-bezier(.5,.85,.25,1.15)] before:absolute before:inset-x-0 before:bottom-0 before:h-1/3 before:bg-gradient-to-t before:from-black/50 before:transition-opacity md:before:opacity-0 md:hover:before:opacity-100 focus-within:before:opacity-100 after:opacity-0 md:group-hover:[&:not(:hover)]:after:opacity-100 md:group-focus-within:[&:not(:focus-within):not(:hover)]:after:opacity-100 after:absolute after:inset-0 after:bg-white/30 after:backdrop-blur after:transition-all focus-within:ring focus-within:ring-indigo-300">
              <Link className="absolute inset-0 text-white z-10" to="/pressure-transmitter">
                <span className="text-center absolute inset-x-0 bottom-0 text-7xl font-bold p-6 md:px-12 md:py-8 md:whitespace-nowrap md:truncate md:opacity-0 group-hover/article:opacity-100 group-focus-within/article:opacity-100 md:translate-y-2 group-hover/article:translate-y-0 group-focus-within/article:translate-y-0 transition duration-200 ease-[cubic-bezier(.5,.85,.25,1.8)] group-hover/article:delay-300 group-focus-within/article:delay-300">Transmitter</span>
              </Link>
              <img className="object-cover h-72 md:h-[480px] md:w-auto" src={Transmitter} width="960" height="480" alt="Transmitter" />
            </article>
            <article className="group/article relative w-full rounded-xl overflow-hidden md:group-hover:[&:not(:hover)]:w-[20%] md:group-focus-within:[&:not(:focus-within):not(:hover)]:w-[20%] transition-all duration-300 ease-[cubic-bezier(.5,.85,.25,1.15)] before:absolute before:inset-x-0 before:bottom-0 before:h-1/3 before:bg-gradient-to-t before:from-black/50 before:transition-opacity md:before:opacity-0 md:hover:before:opacity-100 focus-within:before:opacity-100 after:opacity-0 md:group-hover:[&:not(:hover)]:after:opacity-100 md:group-focus-within:[&:not(:focus-within):not(:hover)]:after:opacity-100 after:absolute after:inset-0 after:bg-white/30 after:backdrop-blur after:transition-all focus-within:ring focus-within:ring-indigo-300">
              <Link className="absolute inset-0 text-white z-10" to="/steam-boilers">
                <span className="text-center absolute inset-x-0 bottom-0 text-7xl font-bold p-6 md:px-12 md:py-8 md:whitespace-nowrap md:truncate md:opacity-0 group-hover/article:opacity-100 group-focus-within/article:opacity-100 md:translate-y-2 group-hover/article:translate-y-0 group-focus-within/article:translate-y-0 transition duration-200 ease-[cubic-bezier(.5,.85,.25,1.8)] group-hover/article:delay-300 group-focus-within/article:delay-300">Boilers</span>
              </Link>
              <img className="object-cover h-72 md:h-[480px] md:w-auto" src={boilers} width="960" height="480" alt="boilers" />
            </article>
          </div>
        </div>
      </main>

         <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            About City Cat International
          </h2>
          <div className="h-1 w-24 bg-rose-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 mb-8">
            For over three decades, City Cat International has been a trusted global manufacturer and exporter of premium industrial equipment for the oil, gas, and energy sectors. Founded in 1990, we combine engineering excellence with stringent quality control to deliver reliable solutions that meet the most demanding industry standards.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Mission</h3>
            <p className="text-lg text-gray-700 mb-6">
              To engineer and deliver high-performance industrial equipment that enhances operational efficiency, ensures safety, and reduces environmental impact for our global clients in the energy sector.
            </p>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Global Reach</h3>
            <p className="text-lg text-gray-700">
              With distribution networks spanning 6 continents and partnerships in over 40 countries, we've successfully executed projects in challenging environments from the North Sea to the Middle East and Asia-Pacific regions.
            </p>
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Core Values</h3>
            <ul className="space-y-4">
              <li className="flex items-start">
                <HiOutlineBadgeCheck className="text-rose-600 text-2xl mt-1 mr-3 flex-shrink-0" />
                <span className="text-lg text-gray-700"><strong>Quality Excellence:</strong> ISO 9001:2015 certified manufacturing processes</span>
              </li>
              <li className="flex items-start">
                <RiCustomerService2Fill className="text-rose-600 text-2xl mt-1 mr-3 flex-shrink-0" />
                <span className="text-lg text-gray-700"><strong>Customer Commitment:</strong> 24/7 technical support and customized solutions</span>
              </li>
              <li className="flex items-start">
                <AiOutlineGlobal className="text-rose-600 text-2xl mt-1 mr-3 flex-shrink-0" />
                <span className="text-lg text-gray-700"><strong>Innovation:</strong> Continuous R&D investment (5% of annual revenue)</span>
              </li>
              <li className="flex items-start">
                <RiShipLine className="text-rose-600 text-2xl mt-1 mr-3 flex-shrink-0" />
                <span className="text-lg text-gray-700"><strong>Reliability:</strong> 99.2% on-time delivery record since 2015</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    {/* Enhanced Why Choose Us */}
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Why Industry Leaders Choose City Cat
          </h2>
          <div className="h-1 w-24 bg-rose-600 mx-auto mb-8"></div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            {
              icon: <HiOutlineBadgeCheck />,
              title: "Certified Quality",
              description: "Our ISO 9001:2015, ISO 14001:2015 & ISO 45001:2018 certified manufacturing ensures every product meets international standards"
            },
            {
              icon: <GrUserExpert />,
              title: "Technical Expertise",
              description: "30+ years of specialized engineering knowledge in oil & gas applications"
            },
            {
              icon: <AiOutlineGlobal />,
              title: "Global Compliance",
              description: "Products certified for API, ANSI, ASME, and PED standards worldwide"
            },
            {
              icon: <RiShipLine />,
              title: "Supply Chain Excellence",
              description: "Streamlined logistics with an average 98.7% on-time delivery rate"
            },
            {
              icon: <RiCustomerService2Fill />,
              title: "Lifetime Support",
              description: "Comprehensive maintenance programs and 24/7 technical assistance"
            },
            {
              icon: <SlBadge />,
              title: "Industry Recognition",
              description: "Recipient of the 2022 Global Excellence Award for Industrial Equipment"
            }
          ].map((item, index) => (
            <div 
              key={index} 
              className="bg-gray-50 p-8 rounded-lg border border-gray-200 hover:shadow-lg transition-all duration-300"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="text-rose-600 text-4xl mb-4">{item.icon}</div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
              <p className="text-gray-700">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Industries We Serve */}
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Industries We Serve
          </h2>
          <div className="h-1 w-24 bg-rose-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700">
            Our precision-engineered equipment powers critical operations across multiple sectors
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
          {[
            "Oil & Gas Exploration",
            "Refining & Petrochemicals",
            "Power Generation",
            "Water Treatment",
            "Pipeline Transportation",
            "Marine & Offshore",
            "Chemical Processing",
            "Mining Operations"
          ].map((industry, index) => (
            <div 
              key={index}
              className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 text-center"
            >
              <div className="text-rose-600 text-2xl mb-3">
                <FaIndustry />
              </div>
              <h3 className="font-semibold text-gray-900">{industry}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Certifications Section */}
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Certifications & Accreditations
          </h2>
          <div className="h-1 w-24 bg-rose-600 mx-auto mb-8"></div>
          <p className="text-xl text-gray-700 mb-10">
            Committed to excellence through internationally recognized standards
          </p>
          
          <div className="flex flex-col md:flex-row justify-center items-center gap-8 ">
            <img src={iso1} alt="ISO 9001:2015 Quality Management Certification" className="h-64 cursor-pointer transition-transform hover:scale-105 Certification-section" onClick={() => openModal(iso1)}
            />
            <img 
              src={iso2} 
              alt="ISO 14001:2015 Environmental Management Certification" 
              className="h-64 cursor-pointer transition-transform hover:scale-105 Certification-section"
              onClick={() => openModal(iso2)} 
            />
            <img 
              src={iso3} 
              alt="ISO 45001:2018 Occupational Health & Safety Certification" 
              className="h-64 cursor-pointer transition-transform hover:scale-105 Certification-section"
              onClick={() => openModal(iso3)} 
            />
          </div>
        </div>
      </div>
    </section>

    {/* Testimonial Section */}
    <section className="py-16 bg-rose-50">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Trusted by Global Energy Leaders
          </h2>
          <div className="h-1 w-24 bg-rose-600 mx-auto mb-8"></div>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-white p-8 rounded-lg shadow-md mb-8">
            <p className="text-gray-700 italic text-lg mb-6">
              "City Cat International has been our primary valve supplier for offshore operations since 2015. Their equipment withstands harsh marine environments while maintaining precise flow control."
            </p>
            <div className="flex items-center">
          
              <div className="ml-4">
                <h4 className="font-bold text-gray-900">Junaid Khan</h4>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* CTA Section */}
    <section className="py-16 bg-gradient-to-r from-rose-700 to-rose-900 text-white">
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to Enhance Your Operations?
        </h2>
        <p className="text-xl max-w-2xl mx-auto mb-10">
          Contact our engineering team for customized solutions and technical specifications
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Link 
            to="/contact" 
            className="bg-white text-rose-700 hover:bg-gray-300 font-bold py-3 px-8 rounded-lg transition duration-300"
          >
            Request Technical Consultation
          </Link>
          <a 
            href="tel:+919819600149" 
            className="border-2 border-white hover:bg-rose-800 font-bold py-3 px-8 rounded-lg transition duration-300"
          >
            +91 9819600149
          </a>
        </div>
      </div>
    </section>


         {/* Modal (existing) */}
    {isModalOpen && (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center z-50" onClick={handleClickOutside}>
        <div className="relative bg-white p-4 max-w-3xl w-full">
          <button 
            className="absolute top-2 right-2 text-gray-600 hover:text-rose-600 text-2xl"
            onClick={closeModal}
          >
            &times;
          </button>
          <img 
            src={modalImageSrc} 
            alt="Certification details" 
            className="w-full h-auto" 
          />
        </div>
      </div>
    )}


          <Footer></Footer></></>
    );
};

export default Home;
